import gql from "fraql";
export const banners = gql`
  fragment _ on Banner {
    id
    contentType
    contentText
    customerName

    targetUrl
    imageUrl
    title

    rank
    position
    placement
    rotateAfterSeconds
  }
`;

export const textBanners = gql`
  fragment _ on Banner {
    id
    rank

    contentType
    contentText

    position
    placement
    rotateAfterSeconds
  }
`;
